<script setup lang="ts">
const {
  size = 24,
  color = '#050529',
  fill = 'none',
} = defineProps<{
  size?: number | string;
  color?: string;
  fill?: string;
}>();
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 12H4M4 12L10 6M4 12L10 18"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
